import { z } from '@framework/zod';
import { numericString } from './numericString';
import { withinBounds, minLessThanMax, type TRangeRefine, type IRangeValues } from './rules';

interface IRangeBounds {
  min?: number,
  max?: number,
}

interface ICreateRangeSchemaOptions {
  bounds?: IRangeBounds | null,
  rules?: TRangeRefine[],
}

const createRangeSchema = ({ bounds, rules = [] }: ICreateRangeSchemaOptions = {}) => {
  const allRules: TRangeRefine[] = [
    ...rules,
    ...(bounds ? [withinBounds(bounds.min, bounds.max)] : []),
    minLessThanMax,
  ];

  return z
    .object({ min: numericString, max: numericString })
    .superRefine((values, ctx) => {
      allRules.forEach((rule) => rule(values as IRangeValues, ctx));
    });
};

export { createRangeSchema };
export type { ICreateRangeSchemaOptions, IRangeBounds };
